import useStableObjectReference from 'hooks/useStableObjectReference'
import usePrevious from 'hooks/usePrevious'

function useMerchandiseSortWasApplied(currentFilters: App.MerchandiseFilters): boolean {
  const stableFilters = useStableObjectReference(currentFilters)
  const previousFilters = usePrevious(stableFilters)

  if (!previousFilters) return false

  return previousFilters.sortBy !== stableFilters.sortBy
}

export default useMerchandiseSortWasApplied
